module.exports = __webpack_public_path__ + "static/media/homeText.74e8de71.md";